import React, { useEffect, useRef, useState } from "react";
import MobileIcon from "../../../assets/icons/ABHA-icons/mobile-icon";
import axios from "axios";
import errorToast from "../../helper-components/error-toast";
import { url } from "../../../redux/config";
import successToast from "../../helper-components/success-toast";
import AddButton from "../../buttons/button";
import { handleShowErrorToast } from "../../helper-components/helper-function";
import InputField from "../../forms/input-field";
import { Upload, Check, RefreshCw } from "lucide-react";
import LeftArrowIcon from "../../../assets/icons/ABHA-icons/left-arrow-icon";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import ClockIcon from "../../../assets/icons/ABHA-icons/clock-icon";
import ResendIcon from "../../../assets/icons/ABHA-icons/resend-icon";
import InfoIcon from "../../../assets/icons/ABHA-icons/info-icon";
import TickIcon2 from "../../../assets/icons/ABHA-icons/tick2-icon";
import TickIcon4 from "../../../assets/icons/ABHA-icons/tick4-icon";

function ListPage({
  txnId,
  adhaarNo,
  adhaarAccessToken,
  setTxnId,
  message,
  setmessage,
  setMethod,
  setStatus,
  setPosition,
  tokenExpiresIn,
  closeModal,
  setAdhaarSuccessData,
  setAdhaarX_Token,
  ABHAlist,
  setAdhaarAccessToken,
}) {
  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const [timeLeft, setTimeLeft] = useState(tokenExpiresIn || 1800); // 2:00 in seconds
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  // State for selected ABHA Number
  const [selectedABHANumber, setSelectedABHANumber] = useState(null);

  const inputRefs = useRef([]);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  // Handler for radio button selection
  const handleRadioChange = (abhaNumber) => {
    setSelectedABHANumber(abhaNumber);
    console.log("Selected ABHA Number:", abhaNumber);
  };

  const getABHA = async (data) => {
    setSubmitted(true);

    // Check if an ABHA is selected
    if (!selectedABHANumber) {
      return errorToast("Please select an ABHA account");
    }

    try {
      setLoading(true);
      const response = await axios.post(
        `${url}/abha-integration/request-login-otp-via-abha-number`,
        {
          accessToken: data,
          abhaNumber: selectedABHANumber,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Response:", response);
      console.log("txnid", response?.data?.data?.abdmResponse?.txnId);
      setAdhaarAccessToken(data);
      setTxnId(response?.data?.data?.abdmResponse?.txnId);
      successToast("OTP is sent");

      // setmessage(response?.data?.data?.abdmResponse?.message);
      console.log("--------------------------------", response);
      // setStatus("OTP Verification");
      // setPosition(2);
      setStatus("otp2");
      setLoading(false);
      //   setPopUp(true);

      return response.data;
    } catch (error) {
      console.log("hhhhhhhhhhhhhhhh", error?.response?.data);
      errorToast(error?.response?.data?.message);
      console.error(
        "Error sending OTP:",
        error.response?.data || error.message
      );
      setLoading(false);
      // throw error;
    }
  };
  const getAccessToken = async () => {
    try {
      const response = await axios.post(
        `${url}/abha-integration/generate-session-token`,
        {
          clientId: "SBXID_009917",
          clientSecret: "68bd8f02-4c70-405f-850e-9774da34917d",
          grantType: "client_credentials",
        },
        { headers: { "Content-Type": "application/json" } }
      );

      console.log("1111111111111111111111111", response);
      return response?.data?.data?.sessionToken?.accessToken;
    } catch (error) {
      errorToast(error?.response?.data?.message || "Auth failed");
      // errorToast(error);
      throw error;
    }
  };
  const sendOTP = async () => {
    setLoading(true);
    try {
      const token = await getAccessToken();
      await getABHA(token);
    } catch (err) {
      console.error("Onsave error:", err);
      setLoading(false);
    }
  };

  // const sendOTP = async () => {
  //   setSubmitted(true);

  //   // Check if an ABHA is selected
  //   if (!selectedABHANumber) {
  //     return errorToast("Please select an ABHA account");
  //   }

  //   try {
  //     setLoading(true);
  //     const response = await axios.post(
  //       `${url}/abha-integration/request-login-otp-via-abha-number`,
  //       {
  //         accessToken: adhaarAccessToken,
  //         selectedABHANumber: selectedABHANumber,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     console.log("Response:", response);
  //     successToast("OTP is verified");
  //     setTxnId(response?.data?.data?.abdmResponse?.txnId);
  //     setAdhaarX_Token(response?.data?.data?.abdmResponse?.token);
  //     setAdhaarSuccessData(response?.data?.data?.abdmResponse?.ABHAProfile);
  //     console.log(response?.data?.data?.abdmResponse?.message);
  //     setStatus("OTP2");
  //     setLoading(false);

  //     return response.data;
  //   } catch (error) {
  //     console.log("Error:", error?.response?.data);
  //     errorToast(error?.response?.data?.message);
  //     console.error(
  //       "Error verifying OTP:",
  //       error.response?.data || error.message
  //     );
  //     setLoading(false);
  //   }
  // };

  const updateGender = (data) => {
    if (data === "M") return "Male";
    else if (data === "F") return "Female";
    else return "Transgender";
  };

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 mt-6 h-full flex flex-col gap-6">
        <label
          className=" text-[var(--abha-abha-card-fg)]
        text-[length:var(--abha-method-title2-fs)] font-[var(--abha-method-title-fw)] whitespace-nowrap"
        >
          Select Profile
        </label>

        <div className="flex flex-wrap gap-4">
          {ABHAlist.length > 0 &&
            ABHAlist.map((item, index) => {
              const img = `data:image/png;base64,${item?.profilePhoto}`;
              const isSelected = selectedABHANumber === item.ABHANumber;

              return (
                <div
                  key={index}
                  className={`border p-5 rounded-lg w-[310px] min-h-[200px] cursor-pointer transition-colors flex-shrink-0 ${
                    isSelected
                      ? "border-[var(--primary)]"
                      : "border-[var(--abha-otp-bg)]"
                  }`}
                  onClick={() => handleRadioChange(item.ABHANumber)}
                >
                  <div className="flex flex-row justify-start gap-5">
                    <div
                      className="flex flex-col justify-center items-center gap-5 border 
                        border-[var(--abha-method-card-border-color)] rounded-full text-[var(--abha-abha-card-fg)]"
                    >
                      <img
                        src={img}
                        alt="ABHA Logo"
                        className="w-[96px] h-[96px] rounded-full shadow-lg"
                      />
                    </div>

                    <div className="flex flex-col gap-5 mt-auto">
                      <label className="text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-button-fw)] whitespace-nowrap">
                        {item?.name}
                      </label>
                      <div
                        className="rounded-3xl py-1 px-3 flex w-min flex-row gap-1 justify-center items-center border border-[var(--abha-old-nav-bg)]
                          text-[length:var(--abha-method-label2-fs)] bg-[var(--abha-print-bg)] font-[var(--abha-method-label-fw)] whitespace-nowrap"
                      >
                        <div>
                          <TickIcon4 />
                        </div>
                        <label
                          className="text-[var(--abha-old-nav-bg)]
                            text-[length:var(--abha-method-label2-fs)] font-[var(--abha-method-label-fw)] whitespace-nowrap"
                        >
                          Verified
                        </label>
                      </div>
                    </div>

                    <input
                      type="radio"
                      name="abha-selection"
                      value={item.ABHANumber}
                      checked={isSelected}
                      onChange={() => handleRadioChange(item.ABHANumber)}
                      className="w-5 h-5 accent-blue-600"
                      onClick={(e) => e.stopPropagation()} // Prevent double firing
                    />
                  </div>

                  <div className="flex flex-row justify-between mt-7 text-[length:var(--abha-method-label2-fs)] font-[var(--abha-method-fw)] text-[var(--abha-abha-card-fg)]">
                    <div className="flex flex-col gap-5">
                      <label className="whitespace-nowrap">ABHA Number</label>
                      <label className="whitespace-nowrap">Gender</label>
                    </div>

                    <div className="flex flex-col gap-5">
                      <label className="whitespace-nowrap">
                        {item.ABHANumber}
                      </label>
                      <label className="whitespace-nowrap">
                        {updateGender(item.gender)}
                      </label>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>

        {/* Display selected ABHA Number for debugging */}
        {selectedABHANumber && (
          <div className="text-sm text-blue-600 font-medium">
            Selected ABHA: {selectedABHANumber}
          </div>
        )}

        <div className="flex flex-row gap-3 justify-end sticky bg-white py-4 mt-auto">
          <AddButton
            prefixIcon={false}
            onclkFn={() => closeModal()}
            text={<span>Cancel</span>}
            className="
              flex items-center px-3 py-2 whitespace-nowrap rounded-md gap-[8px]
              cursor-pointer
              text-[var(--primary-button-bg-color)]
              border border-[var(--primary-button-bg-color)]
              text-[length:var(--primary-button-create-fs)]
              font-[var(--primary-button-font-weight)]"
            type="button"
          />
          <AddButton
            prefixIcon={false}
            loading={loading}
            onclkFn={sendOTP}
            text={<span>Send OTP</span>}
            className="
              flex items-center px-3 py-2 whitespace-nowrap rounded-md gap-[8px]
              bg-[var(--primary-button-bg-color)] cursor-pointer
              text-[var(--primary-button-fg-color)]
              border border-[var(--primary-button-bg-color)]
              hover:bg-[var(--primary-button-hover-color)]
              text-[length:var(--primary-button-create-fs)]
              font-[var(--primary-button-font-weight)]"
            type="submit"
          />
        </div>
      </div>
    </div>
  );
}

export default ListPage;
